export const environment = { apiBaseUrl: 'https://test-tabakas-api.gpais.eu', gpaisInternalUrl: 'https://test-vp.gpais.eu' }; 